// Configurazione dei passi del preventivatore. Estendibile: le opzioni "catalogo"
// vengono lette dal JSON del catalogo (API), quelle "inline" da qui.
// showIf: se presente, lo step compare solo quando la condizione è vera.
export const steps = [
  {
    key: "tipologia", titolo: "Tipologia di funerale", sottotitolo: "Come desidera procedere?",
    tipo: "single", source: "inline",
    options: [
      { nome: "Inumazione", descrizione: "Sepoltura in campo di terra", prezzo: 900 },
      { nome: "Tumulazione", descrizione: "Sepoltura in loculo o tomba", prezzo: 1200 },
      { nome: "Cremazione", descrizione: "Cremazione con affido ceneri", prezzo: 1000 },
    ],
  },
  { key: "bara", titolo: "Scelta della bara", sottotitolo: "Selezioni il cofano", tipo: "single", source: "catalogo", categoria: "bare" },
  {
    key: "finiture", titolo: "Finiture della bara", sottotitolo: "Personalizzi il cofano (facoltativo)",
    tipo: "multi", source: "inline", optional: true,
    options: [
      { nome: "Maniglie in ottone", descrizione: "Maniglie pregiate", prezzo: 120 },
      { nome: "Imbottitura pregiata", descrizione: "Interni in raso", prezzo: 140 },
      { nome: "Croce", descrizione: "Croce applicata", prezzo: 60 },
      { nome: "Decorazioni intagliate", descrizione: "Intagli artigianali", prezzo: 90 },
      { nome: "Incisioni personalizzate", descrizione: "Targa incisa", prezzo: 70 },
    ],
  },
  {
    key: "urna", titolo: "Urna cineraria", sottotitolo: "Selezioni l'urna (facoltativo)",
    tipo: "single", source: "catalogo", categoria: "urne", optional: true,
    showIf: (sel) => sel.tipologia?.nome === "Cremazione",
  },
  {
    key: "lapide", titolo: "Lapide", sottotitolo: "Selezioni la lapide (facoltativo)",
    tipo: "single", source: "catalogo", categoria: "lapidi", optional: true,
    showIf: (sel) => ["Inumazione", "Tumulazione"].includes(sel.tipologia?.nome),
    // Tumulazione in loculo → solo lapidi da muro; inumazione → solo da terra
    filterVariante: (sel) => (sel.tipologia?.nome === "Tumulazione" ? "Loculo" : "Tomba a terra"),
    sottotitoloFor: {
      Tumulazione: "Lapidi da appendere al loculo (facoltativo)",
      Inumazione: "Lapidi da terra per sepoltura (facoltativo)",
    },
  },
  { key: "carro", titolo: "Carro funebre", sottotitolo: "Selezioni il trasporto (facoltativo)", tipo: "single", source: "catalogo", categoria: "carri", optional: true },
  { key: "fiori", titolo: "Addobbi floreali", sottotitolo: "Aggiunga le composizioni (facoltativo)", tipo: "multi", source: "catalogo", categoria: "fiori", optional: true },
  { key: "accessori", titolo: "Ricordi e servizi", sottotitolo: "Manifesti, santini, musica e servizi commemorativi (facoltativo)", tipo: "multi", source: "catalogo", categoria: "accessori", optional: true },
  { key: "pratiche", titolo: "Pratiche burocratiche", sottotitolo: "Documenti e adempimenti amministrativi (facoltativo)", tipo: "multi", source: "catalogo", categoria: "pratiche", optional: true },
  { key: "riepilogo", titolo: "Riepilogo", sottotitolo: "Controlli le sue scelte", tipo: "summary" },
];

export const visibleSteps = (sel) => steps.filter((s) => !s.showIf || s.showIf(sel));

export const categoriaToStep = {
  bare: "bara",
  urne: "urna",
  lapidi: "lapide",
  carri: "carro",
  fiori: "fiori",
  accessori: "accessori",
  pratiche: "pratiche",
};
